module.exports = __webpack_public_path__ + "static/media/screen.a08350c0.png";